import * as React from 'react';
import { Role, useHasPermission, AppPermissions } from '../../../core';
import { PermissionSelection } from './permission-selection-view';

interface IRoleDetailsProps {
  role: Role;
  updateRole: (id: string, permissions: string[]) => void;
  updating?: boolean;
  deleteRole: (id: string) => void;
  deleting?: boolean;
}

const RoleDetails: React.FunctionComponent<IRoleDetailsProps> = (props) => {
  const [permissions, setPermissions] = React.useState<string[]>(
    props.role.permissions || []
  );

  const canUpdateRoles = useHasPermission(AppPermissions.UpdateRoles);
  const canDeleteRoles = useHasPermission(AppPermissions.DeleteRoles);

  return (
    <div className="col-md-8 col-12 member-detail bg-white zIndex-1 top-0 left-0 h-100 overflow-auto">
      <div className="text-right d-md-none p-2">
        <i className="icon-close"></i>
      </div>
      <div className="px-4 pt-4">
        <div className="row align-items-center">
          <div className="col-md-10 col-12 mb-sm-0 mb-2">
            <h4 className="font-weight-semibold mb-1">{props.role?.name}</h4>
            {/* <p className="font-sm font-weight-semibold text-gray-500 mb-0">Last updated by Ajithepalakkad 18/02/2021 05:30 pm</p> */}
          </div>
          {canDeleteRoles && (
            <div className="col-2 text-right p-2">
              <button
                type="button"
                className="btn py-2 font-weight-semibold font-normal px-4 mr-1"
                title="Delete Role"
                disabled={props.deleting}
                onClick={() => props.deleteRole(props.role._id!)}
              >
                <i className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"></i>
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="p-4">
        <div className="row align-items-center no-gutters">
          <div className="col-12 d-flex align-items-center mb-sm-0 mb-2">
            <div className="col-12 px-0">
              <PermissionSelection
                default={permissions}
                onChange={(newPermissions) => {
                  setPermissions(newPermissions);
                }}
                disabled={!canUpdateRoles}
              />
              {canUpdateRoles && (
                <div className="form-group font-weight-semibold mb-3 text-right pt-5">
                  <button
                    className="btn btn-primary font-weight-semibold font-normal px-5"
                    disabled={props.updating}
                    onClick={() =>
                      props.updateRole(props.role!._id!, permissions)
                    }
                  >
                    <span className="px-3">Update Permissions</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleDetails;
